import React, { useEffect } from "react";
import { Carousel, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Categories from "../components/Categories";
import WhyChooseUs from "../components/WhyChooseUs";
import EcoCommitment from "../components/EcoCommitment";
import ManufacturingProcess from "../components/ManufacturingProcess";
import DistributionNetwork from "../components/DistributionNetwork";
import ResearchInnovation from "../components/ResearchInnovation";
import Testimonials from "../components/Testimonials";
import StatsCounter from "../components/StatsCounter";
import ProductHighlights from "../components/ProductHighlights";
import CTASection from "../components/CTASection";
import MapSection from "../components/MapSection";

function Home() {
  // scroll animation (one time for home page)
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <section className="hero-section">
        <Carousel fade interval={4500} controls indicators>

          {/* SLIDE 1 */}
          <Carousel.Item>
            <div className="hero-slide slide-one">
              <Container>
                <h1>Growing Stronger Farms</h1>
                <p>
                  Hindustan Agro Life delivers safe, reliable, and eco-responsible
                  agricultural solutions designed for Indian farmers.
                </p>
                <Button as={Link} to="/about" className="hero-btn">
                  Know More
                </Button>
              </Container>
            </div>
          </Carousel.Item>

          {/* SLIDE 2 */}
          <Carousel.Item>
            <div className="hero-slide slide-two">
              <Container>
                <h1>Protecting Nature. Empowering Farmers.</h1>
                <p>
                  Our bio-based fertilizers, plant nutrition, and crop care inputs
                  support higher yields without harming soil or environment.
                </p>
                <Button as={Link} to="/products" className="hero-btn">
                  Our Products
                </Button>
              </Container>
            </div>
          </Carousel.Item>

          {/* SLIDE 3 */}
          <Carousel.Item>
            <div className="hero-slide slide-three">
              <Container>
                <h1>Innovation Backed by Field Knowledge</h1>
                <p>
                  Every Hindustan Agro Life product is field-tested and developed
                  through real farmer challenges and scientific research.
                </p>
                <Button as={Link} to="/product-details" className="hero-btn">
                  View Solutions
                </Button>
              </Container>
            </div>
          </Carousel.Item>

          {/* SLIDE 4 */}
          <Carousel.Item>
            <div className="hero-slide slide-four">
              <Container>
                <h1>Sustainable Agriculture for Tomorrow</h1>
                <p>
                  We help farmers reduce chemical dependency while maintaining soil
                  fertility, crop strength, and long-term productivity.
                </p>
                <Button as={Link} to="/contact" className="hero-btn">
                  Contact Us
                </Button>
              </Container>
            </div>
          </Carousel.Item>

        </Carousel>
      </section>
      <section className="section about-section">
        <Container>

          {/* Section Heading */}
          <div className="section-title fade-up">
            <h2>About Hindustan Agro Life</h2>
            <p>
              A responsible agricultural solutions company committed to farmer
              success, soil health, and sustainable farming.
            </p>
          </div>

          <Row className="align-items-center">

            {/* TEXT SIDE */}
            <Col lg={6} className="fade-up">
              <div className="about-content">
                <h3>Building Stronger Agriculture with Responsibility</h3>
                <p>
                  Hindustan Agro Life is a professionally managed agri-input
                  company engaged in developing and delivering high-quality,
                  eco-friendly agricultural solutions for Indian farmers.
                </p>

                <p>
                  Our product portfolio includes bio-based fertilizers, plant
                  nutrition solutions, growth stimulants, micronutrients, and
                  environmentally responsible crop care inputs designed to
                  perform under real field conditions.
                </p>

                <p>
                  By integrating natural solutions with modern agricultural
                  technology, we help farmers improve yields, strengthen soil
                  fertility, and reduce dependency on harmful chemicals.
                </p>
              </div>
            </Col>

            {/* IMAGE SIDE */}
            <Col lg={6} className="fade-up">
              <div className="about-image">
                <img
                  src="/images/img/about.png"
                  alt="Sustainable Agriculture"
                  className="img-fluid"
                />
              </div>
            </Col>

          </Row>
        </Container>
      </section>
      <Categories />
      <WhyChooseUs />
      <EcoCommitment />
      <ProductHighlights />
      <ManufacturingProcess />
      <DistributionNetwork />
      <StatsCounter />
      <Testimonials />
      <ResearchInnovation />
      <MapSection />
      <CTASection />
    </>
  );
};

export default Home;
